import React, { useState } from "react";
import { Paper, Stack } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ReferralInfoForm from "./ReferralInfoForm";
import { MyButton, MyTypography } from "../../../common/components";

const ReferralInfoContainer = ({ details, isDraft, referralUuid, refetch }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [saving, setSaving] = useState(false);

  return (
    <Paper
      sx={{
        flex: 1,
        width: "100%",
        borderRadius: 3,
        border: 1,
        borderColor: (theme) => theme.palette.divider,
        p: 3,
        backgroundColor: "background.paper",
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CalendarMonthIcon />
          <MyTypography variant="h3">Referral Information</MyTypography>
        </Stack>

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {!isDraft && (
            <>
              {isEditMode ? (
                <>
                  <MyButton
                    type="button"
                    variant="outlined"
                    onClick={() => setIsEditMode(false)}
                    disableElevation
                    disabled={saving}
                  >
                    Cancel
                  </MyButton>

                  <MyButton
                    type="submit"
                    variant="contained"
                    form="referral-info-form"
                    disableElevation
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save"}
                  </MyButton>
                </>
              ) : (
                <MyButton
                  type="button"
                  variant="contained"
                  onClick={() => setIsEditMode(true)}
                  disableElevation
                >
                  Edit Referral Data
                </MyButton>
              )}
            </>
          )}
        </Stack>
      </Stack>

      {/* Referral Info Form */}
      <ReferralInfoForm
        details={details}
        edit={isEditMode}
        setIsEditMode={setIsEditMode}
        referralUuid={referralUuid}
        refetch={refetch}
        setSaving={setSaving}
      />
    </Paper>
  );
};

export default ReferralInfoContainer;
